import { render, staticRenderFns } from "./FeeMain.vue?vue&type=template&id=571f18ce&scoped=true"
import script from "./FeeMain.vue?vue&type=script&lang=js"
export * from "./FeeMain.vue?vue&type=script&lang=js"
import style0 from "./FeeMain.vue?vue&type=style&index=0&id=571f18ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f18ce",
  null
  
)

export default component.exports